import { render, staticRenderFns } from "./PointModal.vue?vue&type=template&id=d87f998e"
import script from "./PointModal.vue?vue&type=script&lang=js"
export * from "./PointModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports